"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormatToServer = exports.defaultDateFormat = void 0;
exports.defaultDateFormat = 'dd/MM/yyyy';
exports.dateFormatToServer = 'yyyy/MM/dd';
//# sourceMappingURL=dateFormat.js.map